import React from "react";
import { Code2 } from "lucide-react";
import PageHeader from "components/ui/PageHeader";

const DeveloperHeader: React.FC = () => (
    <PageHeader
        icon={<Code2 className="w-5 h-5" />}
        iconBg="bg-violet-50 dark:bg-violet-900/20"
        iconColor="text-violet-600 dark:text-violet-400"
        accentColor="bg-gradient-to-r from-violet-500 to-purple-500"
        title="Developer Settings"
        subtitle="Manage API keys and developer credentials"
    />
);

export default DeveloperHeader;
